// Lightweight CSS-keyframe spinner. The `.rg-spin` animation + reduced-motion handling
// live in the global stylesheet injected by TenantLayout.
export function Spinner({ size = 18, thickness = 2.5, color = "var(--brand)", track = "rgba(0,0,0,0.12)" }: {
  size?: number;
  thickness?: number;
  color?: string;
  track?: string;
}) {
  return (
    <span
      className="rg-spin"
      aria-hidden
      style={{ width: size, height: size, borderStyle: "solid", borderWidth: thickness, borderColor: track, borderTopColor: color }}
    />
  );
}
